import script from "./PelLoanConfigurationModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./PelLoanConfigurationModal.vue?vue&type=script&setup=true&lang=ts"

import "./PelLoanConfigurationModal.vue?vue&type=style&index=0&id=955e421c&lang=css"

const __exports__ = script;

export default __exports__